import { createAction } from '@reduxjs/toolkit';

const listYourCar = createAction('listYourCar/process');

export { listYourCar };
